import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const SCHEDULING_TASKS_URL = `${SERVER_API}/scheduling/tasks`;

export const SCHEDULING_TASKS_ENDPOINTS = {
  ...generateCrudEndpoints(SCHEDULING_TASKS_URL),
  TYPES: {
    method: 'GET',
    url: `${SCHEDULING_TASKS_URL}/types`,
  } as IEndpointData,
  SCHEDULES(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SCHEDULING_TASKS_URL}/${id.toString()}/schedules`,
    };
  },
  DISABLE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SCHEDULING_TASKS_URL}/${id.toString()}/disable`,
    };
  },
  ENABLE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SCHEDULING_TASKS_URL}/${id.toString()}/enable`,
    };
  },
  RUN(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SCHEDULING_TASKS_URL}/${id.toString()}/run`,
    };
  },
  STOP(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${SCHEDULING_TASKS_URL}/${id.toString()}/stop`,
    };
  },
};
